import { post } from '@alltrails/core/utils/post';
import type { ExploreMap } from '@alltrails/types/Map';

type UpdatePrivacyResponse = {
  maps: ExploreMap[];
  meta: { items: number; status: string; timestamp: string };
  pageInfo?: string;
};

const updateMapPrivacy = async (id: string | number, contentPrivacy: string, trailId?: number) =>
  post<UpdatePrivacyResponse>(`/api/alltrails/maps/${id}/metadata`, { contentPrivacy, trail_id: trailId, detail: 'deep' });

export default updateMapPrivacy;
